<script setup lang="ts">
import Accordion from "@/components/Accordion.vue"
import AccordionItem from "@/components/AccordionItem.vue"
import type { ParticipantListDto } from "@/model/championship/participant-list-dto"
import { useHttpGet } from "@/vf"

const props = defineProps<{
    element: any
}>()

const { data: participantList } = await useHttpGet<ParticipantListDto>(
    "/championship/registration/" + props.element.config.selectedChampionship + "/registrations/participant-list",
)
</script>

<template>
    <Accordion v-if="participantList" open-first>
        <AccordionItem
            v-for="(categoryGroup, index) in participantList.categoryGroups"
            :key="categoryGroup.name || index"
            :id="`participant-list-category-${index}`"
            :title="categoryGroup.name || 'Unbenannte Kategorie'"
        >
            <div
                v-if="
                    categoryGroup.championshipCategories && Object.keys(categoryGroup.championshipCategories).length > 0
                "
            >
                <div
                    v-for="championshipCategory in Object.values(categoryGroup.championshipCategories)"
                    :key="championshipCategory.id"
                    class="mb-4"
                >
                    <h5 v-if="championshipCategory.name" class="mb-3">{{ championshipCategory.name }}</h5>

                    <div v-if="championshipCategory.teams && Object.keys(championshipCategory.teams).length > 0">
                        <div class="d-none d-md-block mb-5">
                            <table class="table table-striped">
                                <tbody>
                                    <tr>
                                        <th style="width: 5%">#</th>
                                        <th style="width: 35%">Team</th>
                                        <th style="width: 40%">Organisation</th>
                                        <th style="width: 20%">Country</th>
                                    </tr>
                                    <tr
                                        v-for="(team, teamIndex) in Object.values(championshipCategory.teams)"
                                        :key="team.id"
                                    >
                                        <td>{{ teamIndex + 1 }}</td>
                                        <td>{{ team.teamName }}</td>
                                        <td>{{ team.organization }}</td>
                                        <td>{{ team.country }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div class="d-block d-md-none">
                            <div
                                v-for="team in Object.values(championshipCategory.teams)"
                                :key="team.id"
                                class="py-3"
                                style="border-bottom: 1px solid #ccc"
                            >
                                <div>{{ team.teamName }}</div>
                                <div class="text-muted small">{{ team.organization }} ({{ team.country }})</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </AccordionItem>
    </Accordion>
</template>
